import { FoodTextContext } from "../context/FoodTextContext";
import { useContext } from "react";

export const useFoodTextContext = () => {
    const context = useContext(FoodTextContext);

    if (!context) {
        return Error('useFoodTextContext must be used inside an FoodTextContextProvider');
    };

    return context;
};